import React from 'react'
import styled, { css } from 'styled-components'
import { ThinArrow } from '../categories'

export const TextGridHeader = styled.div<{ isVisible?: boolean }>`
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    font-family: interface, helvetica, arial;
    opacity: 0;
    margin-top: 10px;

    ${(props) =>
        props.isVisible &&
        css`
            opacity: 1;
        `}
`

const MoreStyles = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
        padding-left: 2px;
    }
`

export const MadeByYou = ({ onClick, hasTextResults }: { onClick: () => void; hasTextResults: boolean }) => (
    <TextGridHeader isVisible>
        <div>Made by You</div>
        {hasTextResults && (
            <MoreStyles onClick={onClick}>
                More Styles
                <ThinArrow />
            </MoreStyles>
        )}
    </TextGridHeader>
)
